// extracted by mini-css-extract-plugin
export var ignore = "_72-1";
export var mapping = "_72-0";
export var range = "_72-4";
export var savings = "_72-3";
export var settings = "_72-2";